import { z } from 'zod';

import { DiagramPositionSchema } from './DiagramPosition.schema';

export enum AICommentError {
    NO_LINKED_COMPONENT_INSTANCE = 'noLinkedComponentInstance',
    NO_LINKED_COMPONENT = 'noLinkedComponent',
    NO_LINKED_COMPONENT_FILES = 'noLinkedComponentFiles',
    AI_ERROR = 'aiError',
}

export const DiagramCommentSchema = z.object({
    id: z.string(),
    position: DiagramPositionSchema,
    componentInstances: z.string().array(),
    thread: z
        .union([
            z.object({
                id: z.string(),
                blockType: z.literal('status'),
                user: z.string(),
                date: z.date(),
                status: z.enum(['resolved', 'activated', 'deleted']),
            }),
            z.object({
                id: z.string(),
                blockType: z.literal('view'),
                user: z.string(),
                date: z.date(),
            }),
            z.object({
                id: z.string(),
                blockType: z.literal('message'),
                user: z.string(),
                manufacturer: z.string().nullable(),
                date: z.date(),
                content: z.string(),
                files: z
                    .object({
                        file: z.string(),
                    })
                    .array(),
            }),
            z.object({
                id: z.string(),
                blockType: z.literal('ai'),
                user: z.string(),
                date: z.date(),
                content: z.string(),
                generating: z.boolean(),
                error: z
                    .enum([
                        AICommentError.NO_LINKED_COMPONENT_INSTANCE,
                        AICommentError.NO_LINKED_COMPONENT,
                        AICommentError.NO_LINKED_COMPONENT_FILES,
                        AICommentError.AI_ERROR,
                    ])
                    .nullable(),
            }),
        ])
        .array(),
    user: z.string(), // todo, change with user schema ID
    date: z.date(),
    dateUpdated: z.date(),
    status: z.enum(['created', 'resolved', 'activated', 'deleted']),
    subscribers: z.string().array().default([]),
    seen: z.boolean(),
});
